import React from 'react';

// Иконки кнопок действий в таблицах — тонкая линия NovaFlo вместо эмодзи (✏️ 🔑 🗑️).
// Цвет берут из кнопки (stroke=currentColor), размер по умолчанию 16.
const base = (size) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true,
});

export const EditIcon = ({ size = 16 }) => (
  <svg {...base(size)}><path d="M4 20l4-1L19 8l-3-3L5 16l-1 4z" /><path d="M14 7l3 3" /></svg>
);

export const KeyIcon = ({ size = 16 }) => (
  <svg {...base(size)}><circle cx="7.5" cy="15.5" r="4" /><path d="M10.5 12.5L20 3" /><path d="M16 7l3 3" /><path d="M18.5 4.5l2 2" /></svg>
);

export const TrashIcon = ({ size = 16 }) => (
  <svg {...base(size)}><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M6 6l1 14h10l1-14" /><path d="M10 10v6" /><path d="M14 10v6" /></svg>
);
